<template>
    <div>
        <div class="rubric-show-column-header">
            <div class="title">
                {{ columnIn.title }}
            </div>
            <div
                class="weight"
                v-if="showValues">
                <span class="label">{{ $t('rubrics.weight') }}</span
                >{{ columnIn.value }}
            </div>
        </div>
        <div
            class="rubric-show-row-cell"
            v-for="(row, index) in rowsIn"
            :class="[
                rowHasAnswerForColumn(row, $authUser.id) ? `selected row-${index}` : `row-${index}`,
                edit ? '' : 'rubric-show-row-cell-display-only',
            ]">
            <div
                class="answer"
                @click="edit ? selectCell(row) : null">
                <span v-if="row.hasCellDescription(columnIn)">
                    {{ previewContent(row.getCellDescription(columnIn)) }}
                </span>
            </div>

            <div
                class="rubric-show-selected-row"
                :class="showOtherResults && row.hasAnswerForOtherUsers($authUser.id, columnIn.id) ? 'show' : ''">
                <span
                    class="user"
                    v-for="answer in row.getAnswersForOtherUsersForColumn($authUser.id, columnIn.id)">
                    {{ getUserInitials(answer.user) }}
                </span>
            </div>
        </div>
        <design-2021-rubric-form-cell-description-component
            ref="rubric-cell-description"></design-2021-rubric-form-cell-description-component>
    </div>
</template>

<script>
import { CommonBus } from '../../../app';

export default {
    name: 'design-2021-rubric-form-columns-component',
    props: {
        columnIn: Object,
        rowsIn: Array,
        formsIn: Object,
        showValues: Number,
        rubricAnswers: Array,
        edit: Boolean,
        showOtherResults: Boolean,
    },
    data() {
        return {
            answers: this.rubricAnswers,
        };
    },
    methods: {
        selectCell(row) {
            const answer = {
                column_id: this.columnIn.id,
                row_id: row.id,
                rubric_form_id: this.formsIn.id,
                user_id: this.$authUser.id,
            };

            CommonBus.$emit('rubric-show-add-answer', answer);

            // const hasAnswer = row.rowHasAnswer();
            // const data = {
            //     column_id: this.columnIn.id,
            // }
            //
            // if(hasAnswer){
            //     this.alert.saving();
            //     this.axios.post(this.routes.updateRubricAnswer(row.answers[0].id),data).then (
            //         ((response) => {
            //             row.answers[0].update(response.data);
            //             this.alert.success();
            //         }),
            //         (error) => {
            //             this.alert.ajaxError(error);
            //         }
            //     )
            // }else {
            //     data.rubric_form_id = this.formsIn.id;
            //     data.row_id = row.id;
            //     this.alert.saving();
            //     this.axios.post(this.routes.addRubricAnswer(),data).then (
            //         ((response) => {
            //             row.addRelation('answers', response.data);
            //             this.alert.success();
            //         }),
            //         (error) => {
            //             this.alert.ajaxError(error);
            //         }
            //     )
            // }
        },

        showDescriptionModal(data) {
            this.$refs['rubric-cell-description'].show(data);
        },

        previewContent(rowContent) {
            if (rowContent && rowContent.length > 120) {
                const rawText = rowContent.substring(0, 120) + '...';
                let splitValue = rawText.split(' ');
                splitValue = splitValue.filter((val) => val.indexOf('...') === -1);
                return splitValue.join(' ') + '...';
            }

            return rowContent;
        },

        getUserInitials(user) {
            let initials = '';
            if (user.name) {
                initials = user.name.slice(0, 1);
            }
            if (user.surname) {
                initials += user.surname.slice(0, 1);
            }
            return initials;
        },
        rowHasAnswerForColumn(row, user_id) {
            for (const answer of this.rubricAnswers) {
                if (
                    row.id === answer.row_id &&
                    this.columnIn.id === answer.column_id &&
                    this.formsIn.id === answer.rubric_form_id &&
                    user_id === answer.user_id
                ) {
                    return true;
                }
            }

            return false;
        },
    },
    computed: {},
    watch: {
        rubricAnswers: function (value) {
            this.ansers = value;
        },
    },
};
</script>

<style scoped lang="scss">
.rubric-show-column-header {
    display: flex;
    flex-direction: column;
    flex: 1;
    align-self: flex-start;
    justify-content: center;
    align-items: flex-start;
    border-bottom: 1px solid $border-color;
    border-right: 1px solid $border-color;
    padding: map-get($grid-gutter-spacing, 'eight');
    width: 210px;
    min-height: 50px;
    background-color: $secondary-background-color;
}

.rubric-show-column-header .title {
    font-weight: $font-weight-bolder;
    color: $text-color;
}

.rubric-show-column-header .weight {
    font-weight: $font-weight-medium;
    color: $text-color;
    font-size: $default-font-size;
}

.rubric-show-row-cell {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid $border-color;
    position: relative;
}

.rubric-show-row-cell {
    &:not(.rubric-show-row-cell-display-only) {
        &:hover {
            cursor: pointer;
            border: 3px solid $primary;
        }
    }
}

.rubric-show-row-cell.selected .answer {
    border: 3px solid $primary;
}

.answer {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    padding: map-get($grid-gutter-spacing, 'ten');
    position: relative;
    font-size: $default-font-size;
    font-weight: $font-weight-medium;
    color: $text-muted-color;
    border: 3px solid transparent;
    height: 116px;
}

.rubric-show-selected-row {
    display: none;
}

.rubric-show-selected-row.show {
    display: flex;
    justify-content: flex-end;
    padding: map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'five')
        map-get($grid-gutter-spacing, 'eight') map-get($grid-gutter-spacing, 'eight');
    border-top: 1px solid $border-color;
    border-right: 1px solid $border-color;
    border-bottom: 1px solid $border-color;
    height: 45px;

    .user {
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: $primary;
        color: $white;
        font-size: $default-font-size;
        font-weight: $font-weight-medium;
        border-radius: 30px;
        height: 30px;
        width: 30px;

        &:not(:last-child) {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}
</style>
